import { useEffect, useState } from 'react';
import { BookOpen, ExternalLink } from 'lucide-react';
import { EmptyState, PageHeader } from '@/components';
import './admin.css';

/** 操作マニュアル（ナビ下部リンクの遷移先）。最新版の存在を確認し、新しいタブで開くリンクを出す */
export function ManualPage() {
  const [state, setState] = useState<'checking' | 'ready' | 'none'>('checking');
  useEffect(() => {
    let alive = true;
    fetch('/api/manuals/latest', { method: 'HEAD', credentials: 'include', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((r) => alive && setState(r.ok ? 'ready' : 'none'))
      .catch(() => alive && setState('none'));
    return () => {
      alive = false;
    };
  }, []);
  return (
    <>
      <PageHeader eyebrow="ヘルプ" title="操作マニュアル" description="システムの操作方法をまとめたマニュアルです。最新版が新しいタブで開きます。" />
      <div className="bs-panel">
        {state === 'none' ? (
          <EmptyState icon={<BookOpen />} title="操作マニュアルはまだ登録されていません" description="基金がマニュアル管理から登録すると、ここから開けるようになります。" />
        ) : (
          <EmptyState
            icon={<BookOpen />}
            title="最新版の操作マニュアルを開きます"
            description="ブラウザの新しいタブで表示されます。"
            action={
              <a className="bs-btn bs-btn--primary bs-manual-open" href="/api/manuals/latest" target="_blank" rel="noopener noreferrer" aria-disabled={state === 'checking'}>
                <ExternalLink size={16} aria-hidden /> 最新版を開く
              </a>
            }
          />
        )}
      </div>
    </>
  );
}
